import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import ContactSection from './Contact';
import StatsSection from '../components/Stats';
import FeaturedProducts from '../components/FeaturedProduct';


export const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <FeaturedProducts />
      <StatsSection/>
      <Benefits />
      <Testimonials />
      <ContactSection/>
     
    </div>
  );
};